var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"backtotop",staticClass:"back-to-top"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.jumptotop($event)}}},[_c('arrow-up')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }